const isIOS = /iP(ad|hone|od)/.test(navigator.userAgent)
const isWebKit = /WebKit/.test(navigator.userAgent)
const isNotCriOS = !/CriOS/.test(navigator.userAgent)
const isNotFxiOS = !/FxiOS/.test(navigator.userAgent)

const isIOSSafari = isIOS && isWebKit && isNotCriOS && isNotFxiOS

document.addEventListener('DOMContentLoaded', function() {
    const videos = []
    const videoBlocks = document.querySelectorAll('.video-block')
    for (const videoBlock of videoBlocks) {
        const video = videoBlock.querySelector('video')
        const videoOverlay = videoBlock.querySelector('.video-overlay')

        if (video && !video.hasAttribute('autoplay') && videoOverlay) {
            videoObserver.observe(video)
            videos.push(video)

            videoOverlay.addEventListener('click', event => {
                if (videoBlock.classList.contains('playing')) {
                    video.pause()
                } else {
                    video.play()

                    if (!isIOSSafari) {
                        video.muted = false
                    }
                }
            })

            video.addEventListener('play', event => {
                handlePlayVideo(videoBlock, videoOverlay, video, videos)
            })

            video.addEventListener('pause', event => {
                handlePauseVideo(videoBlock, videoOverlay, video, videos)
            })

            video.addEventListener('ended', event => {
                handleEndedVideo(videoBlock, videoOverlay, video, videos)
            })
        }
    }
})

function handlePauseVideo(videoBlock, videoOverlay, video, videos) {
    videoBlock.classList.remove('playing')
    videoBlock.classList.remove('ended')
    videoBlock.classList.add('paused')
    videoOverlay.setAttribute('aria-label', 'Play video')
    video.setAttribute('tabindex', '0')
}

function handlePlayVideo(videoBlock, videoOverlay, video, videos) {

    // TODO: Confirm this works properly in iOS since it likes to throw hissy fits about programmatic clicks
    for (const v of videos) {
        if (v !== video) {
            v.pause()
        }
    }

    videoBlock.classList.remove('paused')
    videoBlock.classList.remove('ended')
    videoBlock.classList.add('playing')
    videoOverlay.setAttribute('aria-label', 'Pause video')
    video.setAttribute('tabindex', '0')
}

function handleEndedVideo(videoBlock, videoOverlay, video, videos) {
    videoBlock.classList.remove('paused')
    videoBlock.classList.remove('playing')
    videoBlock.classList.add('ended')
    videoOverlay.setAttribute('aria-label', 'Play video')
    video.setAttribute('tabindex', '-1')
}

const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const video = entry.target

            const mp4Source = video.dataset.mp4
            const mp4Type = video.dataset.mp4Type
            if (mp4Source && mp4Type) {
                const source = document.createElement('source')
                source.src = mp4Source
                source.type = mp4Type
                video.appendChild(source)
            }

            const webmSource = video.dataset.webm
            const webmType = video.dataset.webmType
            if (webmSource && webmType) {
                const source = document.createElement('source')
                source.src = webmSource
                source.type = webmType
                video.appendChild(source)
            }

            video.load()
            videoObserver.unobserve(video)
        }
    })
}, {
    rootMargin: '200px 0px',
    threshold: 0.25
})
